


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  private maskPressed(event: any) {
    if (!event.target.className.startsWith || !event.target.className.startsWith('modal-mask')) {
      event.preventDefault();
      return;
    }
    this.$emit('close');
  }
}
